// extracted by mini-css-extract-plugin
export default {"alertContainer":"CustomSnackbar_alertContainer__kMqip"};